// extracted by mini-css-extract-plugin
export default {"page":"style_page__eGKPd","table":"style_table__d2URi","tr":"style_tr__Od6AX","card":"style_card__EHwzE"};